import { render, staticRenderFns } from "./BankAccountDetails.vue?vue&type=template&id=0bdc292a&scoped=true&"
import script from "./BankAccountDetails.vue?vue&type=script&lang=js&"
export * from "./BankAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc292a",
  null
  
)

export default component.exports